const DATE_UNITS = {
  year: 31536000,
  month: 2626560,
  week: 604800,
  day: 86400,
  hour: 3600,
  minute: 60,
  second: 1
}

const getSecondsDiff = timestamp => (Date.now() - timestamp) / 1000

const getUnitAndValueDate = secondsElapsed => {
  for (const [unit, secondsInUnit] of Object.entries(DATE_UNITS)) {
    if (secondsElapsed >= secondsInUnit || unit === 'second') {
      const value = Math.floor(secondsElapsed / secondsInUnit) * -1
      return { value, unit }
    }
  }
}

export default ({ app, redirect }, inject) => {
  inject('toolkit', {
    getLocalDate: utcdate => {
      // const actual = new Date(utcdate)
      // const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }
      // const local = actual.toLocaleString('es-CR', options)

      const date = new Date(utcdate)
      return `${('00' + date.getDate()).slice(-2)}-${('00' + (date.getMonth() + 1)).slice(-2)}-${date.getFullYear().toString().slice(2)} ${(
        '00' + date.getHours()
      ).slice(-2)}:${('00' + date.getMinutes()).slice(-2)}`
    },
    getShortLocalDate: utcdate => {
      const local = new Date(utcdate)
      // const options = { year: 'numeric', month: 'numeric', day: 'numeric' }
      // return local.toLocaleString('es-CR', options)

      return `${('00' + local.getDate()).slice(-2)}-${('00' + (local.getMonth() + 1)).slice(-2)}-${local.getFullYear().toString().slice(2)}`
    },
    getTimeAgo: timestamp => {
      const newTs = new Date(timestamp || new Date())

      const rtf = new Intl.RelativeTimeFormat('es', { numeric: 'auto' })
      const secondsElapsed = getSecondsDiff(newTs)
      const { value, unit } = getUnitAndValueDate(secondsElapsed)

      return rtf.format(value, unit)
    },
    getMinutesAgo: timestamp => {
      const newTs = new Date(timestamp || new Date())
      const minutesElapsed = getSecondsDiff(newTs) / 60

      return Number(minutesElapsed.toFixed(0))
    },
    getMonth(i) {
      return ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'][i - 1]
    },
    getDatesInRange(s, e) {
      for (var a = [], d = new Date(s); d <= new Date(e); d.setDate(d.getDate() + 1)) {
        if (new Date(d) <= new Date()) a.push(this.getShortLocalDate(new Date(d)))
      }
      return a
    },
    getMonthsInRange(s, e) {
      for (var a = [], d = new Date(s).getMonth() + 1; d <= new Date(e).getMonth() + 1; d++) {
        if (d <= new Date().getMonth() + 1) a.push(this.getMonth(d))
      }

      return a
    },
    toNumber(val, fix = 2, thousandsSeparator = ' ') {
      let vale = typeof val === 'string' ? Number(val) : val

      return val ? vale.toFixed(fix).replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator) : 0
    },
    fixFloat(value, decimals = 5) {
      const SCALE = BigInt(10 ** decimals)
      const intValue = BigInt(Math.round(value * Number(SCALE)))

      const fractional = intValue % SCALE

      // If fractional is very close to 0 → snap to 0
      if (fractional <= 2n) {
        return Number(intValue - fractional) / Number(SCALE)
      }

      // If fractional is very close to SCALE → snap to next integer
      if (fractional >= SCALE - 2n) {
        return Number(intValue + (SCALE - fractional)) / Number(SCALE)
      }

      // Otherwise: keep real decimals (like .5)
      return Number(intValue) / Number(SCALE)
    },
    checkCert(cert) {
      if (!cert) return ''
      const expiresOn = new Date(cert)
      const today = new Date()
      // diferencia en dias
      const diffDays = parseInt((expiresOn - today) / (1000 * 60 * 60 * 24), 10)

      if (diffDays <= 7) return '7'
      else if (diffDays <= 1) return '1'
      else return ''
    },

    isMobile() {
      if (typeof navigator !== 'undefined') {
        return /Mobi|Android/i.test(navigator.userAgent)
      }
      return false
    },

    debounce(fx, delay) {
      var timeoutID = null
      return function () {
        if (timeoutID) {
          clearTimeout(timeoutID)
        }
        const context = this
        const args = arguments
        timeoutID = setTimeout(() => {
          fx.apply(context, args)
        }, delay)
      }
    },
    formatColumn(XLSX, worksheet, colArray, fmt) {
      colArray.forEach(col => {
        const range = XLSX.utils.decode_range(worksheet['!ref'])
        // note: range.s.r + 1 skips the header row
        for (let row = range.s.r + 1; row <= range.e.r; ++row) {
          const ref = XLSX.utils.encode_cell({ r: row, c: col })
          if (worksheet[ref] && worksheet[ref].t === 'n') {
            worksheet[ref].z = fmt
          }
        }
      })
    },
    setColumnWidth(worksheet, cols) {
      const widthObj = []
      for (let col = 0; col < cols; ++col) {
        widthObj.push({ wch: 20 })
      }

      worksheet['!cols'] = widthObj
    },
    fecthUrl(url) {
      return fetch(url, {
        method: 'GET',
        headers: { 'Cache-Control': 'no-cache' }
      })
        .then(response => response.blob())
        .then(blob => URL.createObjectURL(blob))
        .catch(error => {
          console.error('Error fetching image:', error)
        })
    },
    getInitials(text) {
      const exclude = ['de', 'con', 'para', 'por', 'a', 'en', 'el', 'la', 'los', 'las', 'y']
      const palabras = text.toLowerCase().split(' ')
      const palabrasValidas = palabras.filter(palabra => !exclude.includes(palabra))

      const iniciales = palabrasValidas
        .slice(0, 2)
        .map(palabra => palabra.charAt(0).toUpperCase())
        .join('')

      return iniciales
    },
    getDateFromId(id) {
      const timestampHex = id.substring(0, 8)
      const timestamp = parseInt(timestampHex, 16) * 1000
      const itemDate = new Date(timestamp)

      return itemDate
    },
    getDocumento(i) {
      switch (i) {
        case '01':
          return 'Factura Electrónica'
        case '02':
          return 'Nota de Débito'
        case '03':
          return 'Nota de Crédito'
        case '04':
          return 'Tiquete Electrónico'
        case '05':
        case '06':
        case '07':
          return 'Factura de Compras (XML)'
        case '08':
          return 'Factura de Compras'
        case '09':
          return 'Factura de Exportación'
        case '99':
          return 'Otras facturas'
      }
    },
    unique(arr = [], feed = [], key = '_id') {
      const map = new Map()

      for (const item of arr) map.set(item[key], item)
      for (const item of feed) map.set(item[key], item)

      return [...map.values()]
    },

    ciclos: [
      { nombre: 'Oportunidad', color: 'info' },
      { nombre: 'En Contacto', color: 'info' },
      { nombre: 'Conversion', color: 'success' },
      { nombre: 'Fidelizacion', color: 'success' },
      { nombre: 'Retencion', color: 'warning' },
      { nombre: 'Recuperacion', color: 'danger' },
      { nombre: 'Finalizado', color: 'default' }
    ],
    months: [
      {
        name: 'Enero',
        value: 1
      },
      {
        name: 'Febrero',
        value: 2
      },
      {
        name: 'Marzo',
        value: 3
      },
      {
        name: 'Abril',
        value: 4
      },
      {
        name: 'Mayo',
        value: 5
      },
      {
        name: 'Junio',
        value: 6
      },
      {
        name: 'Julio',
        value: 7
      },
      {
        name: 'Agosto',
        value: 8
      },
      {
        name: 'Septiembre',
        value: 9
      },
      {
        name: 'Octubre',
        value: 10
      },
      {
        name: 'Noviembre',
        value: 11
      },
      {
        name: 'Diciembre',
        value: 12
      }
    ],
    paths: [
      { value: 'nulo', label: 'Nulo' },
      { value: '/cajas/administrar', label: 'Abrir - Cerrar Cajas' },
      { value: '/clientes/cron', label: 'Ciclos de Cliente' },
      { value: '/clientes/categorias', label: 'Categorias de Clientes' },
      { value: '/clientes/lista', label: 'Clientes' },
      { value: '/admin/datosatv', label: 'Configuracion' },
      { value: '/compras/comprasXml', label: 'Compras (xml)' },
      { value: '/inventario/consumible', label: 'Consumibles' },
      { value: '/inventario/costosfijos', label: 'Costos Fijos' },
      { value: '/inventario/costosvariables', label: 'Costos Variables' },
      { value: '/facturacion/listaLinks', label: 'Links de Pago' },
      { value: '/facturacion/listaCredito', label: 'Mis Facturas' },
      { value: '/compras/listaCredito', label: 'Mis Compras' },
      { value: '/cajas/lista', label: 'Crear Cajas' },
      { value: '/inventario/descuentos', label: 'Descuentos de Producto' },
      { value: 'clientes/marketing/email', label: 'Email Marketing' },
      { value: '/compras/FacturaCompras', label: 'Facturar Compra' },
      { value: '/facturacion/facturar', label: 'Facturar Venta' },
      { value: '/compras/tipos', label: 'Gastos y Activos' },
      { value: '/compras/listaAnulaciones', label: 'Listar Anulaciones Compras' },
      { value: '/restaurante/lista', label: 'Listar Locales' },
      { value: '/facturacion/listaFacturaCompras', label: 'Listar Facturas de Compras' },
      { value: '/facturacion/listaFactura', label: 'Listar Facturas' },
      { value: '/facturacion/listaFacturaOtro', label: 'Listar Facturas (Otros)' },
      { value: '/facturacion/listaFacturaExportacion', label: 'Listar Facturas de Exportacion' },
      { value: '/facturacion/listaNotaCredito', label: 'Listar Notas Credito' },
      { value: '/facturacion/listaPagos', label: 'Listar Pagos Ventas' },
      { value: '/compras/listaPagos', label: 'Listar Pagos Compras' },
      { value: '/restaurante/listaPedidos', label: 'Listar Pedidos' },
      { value: '/restaurante/listaEliminados', label: 'Listar Eliminados' },
      { value: '/facturacion/listaTiquete', label: 'Listar Tiquetes' },
      { value: '/restaurante/zona', label: 'Listar Zonas y Mesas' },
      { value: '/inventario/categoria', label: 'Categoria de Items' },
      { value: '/inventario/entrada', label: 'Entradas Inventario' },
      { value: '/inventario/merma', label: 'Merma' },
      { value: '/inventario/manufacturado', label: 'Manufacturados' },
      { value: '/inventario/materiaPrima', label: 'Materia Prima' },
      { value: '/inventario/lista', label: 'Movimientos Inventario' },
      { value: '/produccion/ordenes', label: 'Ordenes' },
      { value: '/produccion/producir', label: 'Produccion' },
      { value: '/facturacion/proforma', label: 'Proformas' },
      { value: '/compras/Proveedores', label: 'Proveedores' },
      { value: '/inventario/Servicio', label: 'Servicios' },
      { value: '/facturacion/listaMensajeReceptor', label: 'Recepcion de Facturas' },
      { value: '/restaurante/facturar', label: 'Punto de Venta' },
      { value: '/compras/reporte', label: 'Reporte Compras' },
      { value: '/facturacion/reporte', label: 'Reporte Ventas' },
      { value: '/inventario/reventa', label: 'Reventa' },
      { value: '/admin/roles', label: 'Roles' },
      { value: '/clientes/suscripciones', label: 'Suscripciones' },
      { value: '/restaurante/pedidos', label: 'Tomar Pedidos' },
      { value: '/admin/usuarios', label: 'Usuarios' },
      { value: '/cajas/micaja', label: 'Ver Mi Caja' },
      { value: '/restaurante/cocina', label: 'Ver Pedidos' }
    ],
    pickerOptions: {
      shortcuts: [
        {
          text: 'Esta Semana',
          onClick(picker) {
            const date = new Date()
            let end = date.getDate() - (date.getDay() - 1) + 6
            end = new Date(date.setDate(end))
            end.setHours(23, 59, 59, 0)

            const diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 1)
            const start = new Date(date.setDate(diff))
            start.setHours(0, 0, 0, 0)

            picker.$emit('pick', [start, end])
          }
        },
        {
          text: '7  Días',
          onClick(picker) {
            let end = new Date()
            let start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            start.setHours(0, 0, 0, 0)
            end = new Date(end.getFullYear(), end.getMonth(), end.getDate(), 23, 59, 59)

            picker.$emit('pick', [start, end])
          }
        },
        {
          text: '30 Días',
          onClick(picker) {
            let end = new Date()
            let start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            start.setHours(0, 0, 0, 0)
            end = new Date(end.getFullYear(), end.getMonth(), end.getDate(), 23, 59, 59)

            picker.$emit('pick', [start, end])
          }
        },
        {
          text: '90 Días',
          onClick(picker) {
            let end = new Date()
            let start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            start.setHours(0, 0, 0, 0)
            end = new Date(end.getFullYear(), end.getMonth(), end.getDate(), 23, 59, 59)

            picker.$emit('pick', [start, end])
          }
        }
      ]
    }
  })
}
